module.exports = __webpack_public_path__ + "media/country_flags/bo-6ed63ed3.png";